<template>
  <b-container fluid="md">
    <b-row no-gutters>
      <b-col class="p-0 mb-4">
        <b-carousel
            id="carousel-1"
            class="box-rounded-bottom d-none d-sm-block"
            :interval="4000"
            controls
            indicators
            background="#ababab"
            img-width="960"
            img-height="200"
            style="text-shadow: 1px 1px 2px #333"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
        >
          <b-carousel-slide
              v-for="banner in banners"
              :key="banner.id"
              class="box-rounded-bottom"
          >
            <template v-slot:img>
              <img
                  class="d-block img-fluid w-100"
                  width="960"
                  height="200"
                  :src="banner.src"
                  alt="image slot"
              >
            </template>
          </b-carousel-slide>
        </b-carousel>

        <b-img class="d-sm-none"
         center
         fluid-grow
         :src="require('@assets/banners/banner_06.png')"
         alt="banner">
        </b-img>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { contentComputed } from '@state/helpers';

export default {
  name: "Banner",

  data() {
    return {
      slide: 0,
      sliding: null
    }
  },

  computed: {
    ...contentComputed
  },

  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }
  }
}
</script>

<style>
  ol.carousel-indicators {
    position: absolute;
    bottom: 0;
    margin: 0;
    left: 0;
    right: 0;
    width: auto;
  }

  ol.carousel-indicators li,
  ol.carousel-indicators li.active {
    float: left;
    width: 33%;
    height: 5px;
    margin: 0;
    border-radius: 0;
    border: 0;
    background: transparent;
  }

  ol.carousel-indicators li.active {
    background: silver;
  }

  @media only screen and (min-width: 768px) {
    .box-rounded-bottom {
      overflow-x: hidden;
      border-bottom-right-radius: 10px !important;
      border-bottom-left-radius: 10px !important;
    }
  }

  a.carousel-control-prev span.sr-only,
  a.carousel-control-next span.sr-only {
    display: none;
  }
</style>
